import { CapabilityCitation } from '../types/capabilityCitation';

export const validateCitation = async (citation: CapabilityCitation): Promise<{ valid: boolean; reason?: string }> => {
  // 1. Check URL format
  try {
    new URL(citation.citationURL);
  } catch (e) {
    return { valid: false, reason: "Invalid URL format" };
  }

  // 2. Check Legal Status
  const validStatuses = ['unclassified', 'public-domain', 'open-access'];
  if (!validStatuses.includes(citation.legalStatus)) {
    return { valid: false, reason: "Invalid legal status. Must be unclassified, public-domain, or open-access." };
  }

  // 3. Check Date Freshness (warn if > 10 years, but don't fail validation strictly unless required)
  const pubDate = new Date(citation.datePublished);
  const tenYearsAgo = new Date();
  tenYearsAgo.setFullYear(tenYearsAgo.getFullYear() - 10);
  
  if (pubDate < tenYearsAgo && citation.legalStatus !== 'public-domain') {
    // Historical documents (public-domain) are allowed to be old
    // But current tech refs should be recent
    // For now, we just note it but return valid
  }

  // 4. URL Accessibility Check (Head Request)
  // Note: In a client-side browser environment, CORS often blocks HEAD requests to arbitrary domains.
  // This check is best performed by a backend proxy or during build time.
  // We will simulate a check or skip it for client-side to avoid CORS errors.
  
  return { valid: true };
};

export const checkUrlAccessibility = async (url: string): Promise<boolean> => {
  try {
    const response = await fetch(url, { method: 'HEAD', mode: 'no-cors' });
    // Opaque response (type: 'opaque') from no-cors still means the server is there, 
    // but we can't see the status code. It's better than network error.
    return true; 
  } catch (error) {
    console.warn(`URL check failed for ${url}`, error);
    return false;
  }
};
